import { Button, Form, Input } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TRY_THEN_BUY } from '../../../../constants/define/translation';

interface FormAmountCloseProps {
  onSubmit: (value: string) => void;
  label: string;
  placeholder: string;
  validateMessage: string;
}
export const FormAmountClose = (props: FormAmountCloseProps) => {
  const [form] = Form.useForm();
  const { onSubmit, label, placeholder, validateMessage } = props;
  const { t } = useTranslation(TRY_THEN_BUY);
  return (
    <>
      <Form layout="vertical" form={form} onFinish={onSubmit}>
        <div className="form-content py-2">
          <Form.Item name="amount" label={label} rules={[{ required: true }]} initialValue="0">
            <Input prefix="$" type="number" allowClear defaultValue={0} />
          </Form.Item>
          <Form.Item name="note" label={t('form.note')} rules={[{ message: validateMessage }]}>
            <TextArea placeholder={placeholder} showCount maxLength={1000} />
          </Form.Item>
          <div className="mt-2">
            <Form.Item shouldUpdate>
              {() => (
                <div className="d-flex justify-content-end mt-3">
                  <Button
                    type="primary"
                    size="large"
                    disabled={!!form.getFieldsError().filter(({ errors }) => errors.length).length}
                    id="btnSubmitInput"
                    className="px-4 btn mt-3"
                    htmlType="submit"
                  >
                    {t('form.submit')}
                  </Button>
                </div>
              )}
            </Form.Item>
          </div>
        </div>
      </Form>
    </>
  );
};
